import React from 'react';
import Icon from '../../../components/AppIcon';


const RegistrationFilters = ({
  filterStatus,
  setFilterStatus,
  filterRole,
  setFilterRole,
  filterDateRange,
  setFilterDateRange,
  searchQuery,
  setSearchQuery,
  pendingCount
}) => {
  return (
    <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-4 space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} color="#3B82F6" />
        <h3 className="font-semibold text-white">تصفية الطلبات</h3>
      </div>
      {/* Search */}
      <div>
        <label className="block text-sm font-medium text-muted-foreground mb-2">
          بحث
        </label>
        <div className="relative">
          <Icon name="Search" size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            placeholder="ابحث بالاسم أو البريد..."
            className="w-full pr-10 pl-4 py-2 bg-background border border-border rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      </div>
      {/* Status Filter */}
      <div>
        <label className="block text-sm font-medium text-muted-foreground mb-2">
          حالة الموافقة
        </label>
        <div className="space-y-2">
          {[
            { value: 'all', label: 'الكل', icon: 'List' },
            { value: 'pending_approval', label: 'قيد المراجعة', icon: 'Clock', badge: pendingCount },
            { value: 'approved', label: 'موافق عليهم', icon: 'CheckCircle' },
            { value: 'rejected', label: 'مرفوضين', icon: 'XCircle' }
          ]?.map(status => (
            <button
              key={status?.value}
              onClick={() => setFilterStatus(status?.value)}
              className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors ${
                filterStatus === status?.value
                  ? 'bg-primary text-white' :'bg-background text-muted-foreground hover:bg-muted'
              }`}
            >
              <div className="flex items-center gap-2">
                <Icon name={status?.icon} size={16} />
                <span>{status?.label}</span>
              </div>
              {status?.badge > 0 && (
                <span className="px-2 py-0.5 bg-yellow-500/20 text-yellow-400 rounded-full text-xs font-medium">
                  {status?.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
      {/* Role Filter */}
      <div>
        <label className="block text-sm font-medium text-muted-foreground mb-2">
          نوع المستخدم
        </label>
        <select
          value={filterRole}
          onChange={(e) => setFilterRole(e?.target?.value)}
          className="w-full px-3 py-2 bg-background border border-border rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="all">جميع الأدوار</option>
          <option value="admin">مدير النظام</option>
          <option value="property_manager">مدير الخصائص</option>
          <option value="contract_specialist">أخصائي العقود</option>
          <option value="client_manager">مدير العملاء</option>
          <option value="agent">وكيل</option>
          <option value="manager">مدير</option>
          <option value="staff">موظف</option>
        </select>
      </div>
      {/* Date Range Filter */}
      <div>
        <label className="block text-sm font-medium text-muted-foreground mb-2">
          تاريخ التقديم
        </label>
        <select
          value={filterDateRange}
          onChange={(e) => setFilterDateRange(e?.target?.value)}
          className="w-full px-3 py-2 bg-background border border-border rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="all">جميع التواريخ</option>
          <option value="today">اليوم</option>
          <option value="week">آخر أسبوع</option>
          <option value="month">آخر شهر</option>
        </select>
      </div>
      {/* Clear Filters */}
      <button
        onClick={() => {
          setFilterStatus('all');
          setFilterRole('all');
          setFilterDateRange('all');
          setSearchQuery('');
        }}
        className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-muted hover:bg-muted/80 text-white rounded-lg text-sm transition-colors"
      >
        <Icon name="X" size={16} />
        <span>مسح الفلاتر</span>
      </button>
    </div>
  );
};

export default RegistrationFilters;